export const linkEvent = '$quick_search_click'
